import React from "react"

import MaterialReactTable, { MRT_ColumnDef } from "material-react-table"

import { ContentListTableProps, ContentListTableState } from "./models"

import {
	IconButton,
	Stack,
	Box,
	Typography
} from "@mui/material"

import EditIcon from "@mui/icons-material/Edit"
import DeleteIcon from "@mui/icons-material/Delete"

import { t } from "@lingui/macro"
import {RouteComponentProps, withRouter} from "react-router-dom";
import {ConfirmModal} from "commons/modal/confirm-modal";
import { ContentDescription } from "models"
import { selectDescriptionByLanguage } from "utils"


class ContentListTable extends React.Component<ContentListTableProps & RouteComponentProps<any>, ContentListTableState>
{

	private tableColumns: MRT_ColumnDef[];

	private getLanguageValue = (row: any): string => {
		return row.original.language
	}

	public constructor(props: any) {

		super(props)

		this.state={
			openConfirmModal: false,
			contentListToDelete: ""
		}

		this.tableColumns = [
			{
				header: t({
					id: "clt-table-col-title",
					message: "Titolo"
				}),
				accessorKey: "title",
				Cell: ({ cell, row }) => {
					return (
						<Typography>
							{selectDescriptionByLanguage(cell.getValue<ContentDescription[]>(), this.getLanguageValue(row))}
						</Typography>
					);
				},
			},
			{
				header: t({
					id: "clt-table-col-priority",
					message: "Priorità"
				}),
				accessorKey: "priority",
			},
			{
				header: t({
					id: "clt-table-col-featured-from",
					message: "In evidenza dal"
				}),
				accessorKey: "featuredFrom",
				Cell: ({ cell }) => {
					return (
						<Box>
							{cell.getValue<string>() && (new Date(cell.getValue<string>())).toLocaleDateString("it-IT")}
						</Box>
					);
				},
			},
			{
				header: t({
					id: "clt-table-col-featured-to",
					message: "In evidenza al"
				}),
				accessorKey: "featuredTo",
				Cell: ({ cell }) => {
					return (
						<Box>
							{cell.getValue<string>() && (new Date(cell.getValue<string>())).toLocaleDateString("it-IT")}
						</Box>
					);
				},
			}
		];
	}

	private openConfirmModal = (id: string) : void =>{
		this.setState(() => ({
			openConfirmModal: true,
			contentListToDelete: id
		}))
	}

	private cancelConfirmModalCallback = () : void =>{
		this.setState(() => ({
			openConfirmModal: false,
			contentListToDelete: ""
		}))
	}

	private acceptConfirmModal = () : void =>{
		this.setState(() => ({
			openConfirmModal: false,
		}))
		this.deleteContentList()
	}

	private deleteContentList = (): void => {
		this.props.deleteContentList(this.state.contentListToDelete);
		this.setState(() => ({
			contentListToDelete: ""
		}))

	}

	private getIdValue = (row: any): string => {
		return row.original.id
	}


	private handlePageChange = (updateFn: any) => {
			let newPagination = updateFn(this.props.pagination);
			this.props.updatePaginationCallBackFn(newPagination);
	}

	private goEdit = (row: any): void => {
		let { history } = this.props
		history.push(`/backoffice/edit-content-list/${this.getIdValue(row)}`);
	}

	render() {
		return (<>
			<Box style={{ maxWidth: '100%' }}>
				<MaterialReactTable
					columns={this.tableColumns}
					rowCount={this.props.totalContentListsCount}
					data={this.props.contentLists}
					enableRowSelection={false}
					enableColumnOrdering
					enableGlobalFilter={false}
					enableFilters={false}
					muiTableHeadCellProps={{
						sx: {
							color: "white",
							backgroundColor: process.env.REACT_APP_PRIMARY_COLOR
						}
					}}
					displayColumnDefOptions={{
						'mrt-row-actions': {
							header: ""
						},
					}}
					enableRowActions
					positionActionsColumn="last"
					renderRowActions={({ row }) => (
						<Stack direction={"row"} display={"flex"} justifyContent={"right"} >
							<IconButton onClick={() => this.goEdit(row)}>
								<EditIcon />
							</IconButton>
							<IconButton onClick={() => this.openConfirmModal(this.getIdValue(row))}>
								<DeleteIcon />
							</IconButton>
						</Stack>
					)}
					onPaginationChange={this.handlePageChange}
					enableTopToolbar={false}
					manualPagination={true}
					enableDensityToggle={false}
					state={{ pagination: this.props.pagination }}
					initialState={{ pagination: this.props.pagination }} />
			</Box>
			{this.state.openConfirmModal && < ConfirmModal
				cancelConfirmCallback={this.cancelConfirmModalCallback}
				confirmCallback={this.acceptConfirmModal}
				text={"Sei sicuro di voler procedere con l'eliminazione della lista di contenuti?"}
				textId={"clt-delete-content-list-text"}
			/>}
		</>)
	}
}

export default withRouter(ContentListTable);